import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export enum NativeActionsEnum {
  AuthTokenExpired = 'auth:token_expired',
  WebviewInit = 'webview:init',
  NavigationBack = 'navigation:back',
  NavigationHome = 'navigation:home',
  NavigationActivity = 'navigation:activity',
  NavigationUpload = 'navigation:upload',
  OpenSlideup = 'slideup:open',
  CloseSlideup = 'slideup:close',
  LinkOpen = 'link:open',
  OpenForgotPassword = 'forgotPassword:open',
  SignOut = 'signout',
  UserUpdated = 'user:updated',
  PlanSelected = 'plan:selected',
  Continue = 'continue',
  OpenStoreSettings = 'storeSettings:open',
  Plans = 'plans',
  Cancel = 'cancel',
  ContactUs = 'contactUs',
  ShowUpgradeBundle = 'show_upgrade_bundle',
  Locale = 'locale',
  Resubscribe = 'resubscribe',
  Basic = 'basic',
}

export interface PostMessageData {
  type: NativeActionsEnum
  data?: unknown
}

export const useWebviewStore = defineStore('webview', () => {
  const topSafeAreaHeight = ref(0)
  const bottomSafeAreaHeight = ref(0)

  const showNavbar = ref(false)

  const handleScroll = (event: Event) => {
    showNavbar.value = (event.target as HTMLElement).scrollTop >= 84
  }

  const isiOS = computed(
    () =>
      !!window.webkit && !navigator.userAgent.toLowerCase().includes('safari')
  )

  const isAndroid = computed(() => !!window.Android)

  const isActive = ref(
    !!(isiOS.value || isAndroid.value) &&
      navigator.userAgent.toLowerCase().includes('dacr')
  )

  const postMessage = async (data: PostMessageData) => {
    try {
      if (window.Android) {
        return window.Android.showMessageFromJs(JSON.stringify(data))
      }

      if (window.webkit) {
        return window.webkit.messageHandlers.dacrNative.postMessage(
          JSON.stringify(data)
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  const setTopSafeAreaheight = (value: number) => {
    topSafeAreaHeight.value = value
  }

  const setBottomSafeAreaHeight = (value: number) => {
    bottomSafeAreaHeight.value = value
  }

  return {
    isActive,
    isiOS,
    isAndroid,
    postMessage,
    topSafeAreaHeight,
    bottomSafeAreaHeight,
    setTopSafeAreaheight,
    setBottomSafeAreaHeight,
    showNavbar,
    handleScroll,
  }
})
